require('flatpickr');

function datetimePickerApplyMasks(){
    flatpickr('.datepicker', {
        enableTime: false,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'n/d/Y',
        altInput: true,
        disableMobile: "true",
        static: true
    });

    flatpickr('.datepicker-on-datatable', {
        enableTime: false,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'n/d/Y',
        altInput: true,
        disableMobile: "true"
    });

    flatpickr('.datetimepicker', {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'n/d/Y h:i K',
        altInput: true,
        disableMobile: "true",
        closeOnSelect: false,
        static: true
    });

    flatpickr('.daterangepicker', {
        enableTime: false,
        dateFormat: 'Y-m-d',
        altFormat: 'n/d/Y',
        altInput: true,
        mode: 'range',
        disableMobile: "true",
        closeOnSelect: false,
        static: true
    });

    flatpickr('.timepicker', {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        altFormat: 'h:i K',
        altInput: true,
        disableMobile: "true",
        closeOnSelect: false,
        static: true
    });
}

datetimePickerApplyMasks();

module.exports = {
    datetimePickerApplyMasks: datetimePickerApplyMasks,
};


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/datetimepicker.js